import React, { memo } from 'react'
import { INavRoute } from 'types/routes'
import SubRoute from './SubRoute'

interface INavLinkProps {
  route: INavRoute
}

export const NavLink = memo<INavLinkProps>(
  ({ route: { childRoutes, isActive, isButton, isPrimary, location, name } }) => {
    const className = `nav-link ${isActive ? 'active' : ''}`
    if (isButton) {
      return (
        <a
          className={`nav-cta ${isPrimary ? 'btn-primary' : 'btn-darkbg'}`}
          href={location}
          data-test={name}>
          {name}
        </a>
      )
    }
    return (
      <li className='fl tc'>
        <a href={location} data-test={name} className={className}>
          <span className='title tc ttc'>{name}</span>
        </a>
        {childRoutes && (
          <ul className='xs-grid-1 sub-menu'>
            {childRoutes
              .filter((childRoute: INavRoute) => !!childRoute.display)
              .map((childRoute: INavRoute) => (
                <SubRoute route={childRoute} key={childRoute.name} />
              ))}
          </ul>
        )}
      </li>
    )
  }
)
